import { NavLink, Link } from 'react-router-dom';
import { Gem, Clapperboard, BookOpen, Headset, HandCoins } from 'lucide-react';
import { useSupportUnreadCount } from '@/contexts/SupportContext';
import { AccountMenu } from './AccountMenu';
import { appPath } from "@/lib/basePath";
const links = [
    { to: '/coach', label: 'My Coach', Icon: Clapperboard },
    { to: '/discover', label: 'Hidden Gem Products', Icon: Gem },
    { to: '/affiliate', label: 'Earn with Coach', Icon: HandCoins },
    { to: '/help', label: 'How to use your coach', Icon: BookOpen },
    { to: '/support', label: 'Support', Icon: Headset },
];
export function Sidebar() {
    const supportUnread = useSupportUnreadCount();
    return <aside className="portal-sidebar">
 <Link to="/coach" className="portal-brand"><img src={appPath("/logo-dark.png")} alt="Brands Meet Creators"/></Link>
 <nav aria-label="Main navigation">{links.map(({ to, label, Icon }) => <NavLink key={to} to={to} className={({ isActive }) => 'portal-nav ' + (isActive ? 'active' : '')}><Icon size={19}/>{label}{to === '/support' && supportUnread > 0 && <b className="nav-badge" aria-label={`${supportUnread} unread`}>{supportUnread}</b>}</NavLink>)}</nav>
 <div className="sidebar-bottom">
  <AccountMenu />
 </div>
 </aside>;
}
